"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavTabs;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const NavTabsStyled = _styledComponents.default.ul`
  margin: 0 -15px;
  padding: 0 15px;
`;
function NavTabs(props) {
  return /*#__PURE__*/_react.default.createElement(NavTabsStyled, {
    className: "nav nav-tabs hidden-print"
  }, props.children);
}